module.exports = __webpack_public_path__ + "static/img/fullscreen-image_success_768.c694c9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/live-hr-advice/fullscreen-image_success_768.png
// module id = TTMd
// module chunks = 0